import React from 'react'
import type { MetricLegajo } from '../../../../../../services/projectAutofillDraftService.ts'
import {
  classifyMetricLegajoDisplay,
  metricLegajoPublishHint
} from '../../../../../../utils/conversationalMode/metricLegajoDisplayUtils.ts'
import styles from './MetricLegajoPreview.module.scss'

type Props = {
  legajo: MetricLegajo
  storageUrl: string | null
  summarizePages: (pages: number[]) => string
}

const MetricLegajoPreview: React.FC<Props> = ({ legajo, storageUrl, summarizePages }) => {
  const kind = classifyMetricLegajoDisplay(legajo)
  const hint = metricLegajoPublishHint(kind, legajo, summarizePages)
  const hintTail = hint.startsWith('Detectamos') ? hint.slice('Detectamos'.length) : hint
  const fileLabel = legajo.originalName?.trim() || 'Archivo detectado'

  const hintLine = (
    <p className={styles.hint}>
      <strong>Detectamos</strong>
      {hintTail}
    </p>
  )

  if (!storageUrl) {
    return (
      <div className={styles.wrap}>
        {hintLine}
        <p className={styles.missingUrl}>No pudimos cargar la vista previa del archivo en este momento.</p>
      </div>
    )
  }

  if (kind === 'image') {
    return (
      <div className={styles.wrap}>
        {hintLine}
        <div className={styles.previewFrame}>
          <img src={storageUrl} alt={fileLabel} className={styles.previewImage} />
        </div>
        <div className={styles.actions}>
          <a href={storageUrl} target="_blank" rel="noopener noreferrer" className={styles.linkBtn}>
            Abrir imagen
          </a>
        </div>
      </div>
    )
  }

  if (kind === 'pdf') {
    return (
      <div className={styles.wrap}>
        {hintLine}
        <div className={styles.previewFrame}>
          <iframe title={fileLabel} src={storageUrl} className={styles.previewPdf} />
        </div>
        <div className={styles.actions}>
          <a href={storageUrl} target="_blank" rel="noopener noreferrer" className={styles.linkBtn}>
            Ver documento
          </a>
        </div>
      </div>
    )
  }

  if (kind === 'spreadsheet') {
    return (
      <div className={styles.wrap}>
        {hintLine}
        <div className={styles.fileCard}>
          <div>
            <p className={styles.fileName}>{fileLabel}</p>
            <p className={styles.fileKind}>Planilla Excel</p>
          </div>
          <a href={storageUrl} target="_blank" rel="noopener noreferrer" className={styles.linkBtn} download>
            Descargar planilla
          </a>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.wrap}>
      {hintLine}
      <div className={styles.actions}>
        <a href={storageUrl} target="_blank" rel="noopener noreferrer" className={styles.linkBtn}>
          Ver archivo
        </a>
      </div>
    </div>
  )
}

export default MetricLegajoPreview
